import type { GetReportsResponsePayload } from '@vy/api-definition';
import { GetReportsResponseSchema } from '@vy/api-definition';
import { validateNotNullOrUndefined } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useReports(options?: CustomUseQueryOptions<GetReportsResponsePayload>) {
  const reportsQuery = useQuery(
    queryKeys.reports(),
    async () => {
      const api = getPrivateApi();
      const getReportsResponse = await api.getReports();

      return GetReportsResponseSchema.parse(getReportsResponse);
    },
    { suspense: true, ...options },
  );

  validateNotNullOrUndefined(reportsQuery.data, 'Reports');

  return reportsQuery;
}
